export const CUSTOMER_SITUATION_DURATION_REQUIRED_MSG =
  "متى يظبط العميل حالته مطلوب عند اختيار تصنيف مرفوض";

export const CUSTOMER_SITUATION_DATE_REQUIRED_MSG =
  "تاريخ ظبط العميل لحالته مطلوب عند اختيار تصنيف مرفوض";

export function hasSelectedProductType(agent) {
  const productType = agent?.req_product_type;
  return productType !== null && productType !== undefined && productType !== "";
}

/**
 * Show situation-fix fields when classification is rejected and a product type is selected.
 */
export function requiresCustomerSituationFix(agent, classId, isRejectedClassFn) {
  if (!agent || classId === null || classId === undefined || classId === "") {
    return false;
  }
  if (!hasSelectedProductType(agent)) {
    return false;
  }
  return typeof isRejectedClassFn === "function" && isRejectedClassFn(classId);
}

export function buildCustomerSituationDurationRules(required) {
  if (!required) return [];
  return [
    (v) =>
      (v !== null && v !== undefined && v !== "") ||
      CUSTOMER_SITUATION_DURATION_REQUIRED_MSG,
  ];
}

export function buildCustomerSituationDateRules(required) {
  if (!required) return [];
  return [(v) => !!v || CUSTOMER_SITUATION_DATE_REQUIRED_MSG];
}

/**
 * Auto-fill situation_improve_date from mortgageDurations store entry.
 */
export function applySituationImproveDateFromDuration(agent, mortgageDurations = []) {
  if (!agent?.mortgage_duration_id) {
    agent.situation_improve_date = "";
    return;
  }

  const mid = agent.mortgage_duration_id;
  const selectedDuration = (mortgageDurations || []).find(
    (duration) => duration.id == mid || String(duration.id) === String(mid)
  );

  if (!selectedDuration?.months) {
    agent.situation_improve_date = "";
    return;
  }

  const endDate = new Date();
  endDate.setMonth(endDate.getMonth() + selectedDuration.months);
  agent.situation_improve_date = endDate.toISOString().substr(0, 10);
}

export function clearCustomerSituationFixFields(agent) {
  if (!agent) return;
  agent.mortgage_duration_id = null;
  agent.situation_improve_date = "";
}
